/* --------------------------------------------------------------------------------------
   browserTable.component.js

   Copyright © 2019 Xerox Corporation. All Rights Reserved.
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const browserTableComponent = {
  template: require("./browserTable.html"),
  bindings: {
    nodes: "<",
    onNodeSwitch: "&",
    selected: "=",
    parentType: "<",
    selectAllowed: "<",
    addAllowed: "<",
    previewNode: "=",
  },
  controllerAs: "vm",
  controller: class BrowserTableCtrl {
    /* @ngInject */
    constructor(browserService, commonService) {
      this.browserService = browserService;
      this.commonService = commonService;
    }

    async $onInit() {
      this.screenSize = this.commonService.getScreenSize();
      this.alta = await this.commonService.isAltalink();
      this.init = true;
    }

    $onChanges() {
      this.selected = [];
      this.addType = this.getAddType();
      if (this.init)
        angular.element("#browser-table-scroll").xrxscrollable("refresh");
    }

    async select(node) {
      if (node.EntryType != "Document") {
        this.selected = node;
      } else {
        this.updateSelectedNodes(node);
      }
      await this.commonService.updateView();
    }

    updateSelectedNodes(node) {
      if (!this.selected.includes(node)) this.selected.push(node);
      else this.selected = this.selected.filter((n) => n != node);
    }

    async open(node) {
      await this.select(node);
      this.onNodeSwitch();
    }

    getAddType() {
      switch (this.parentType) {
        case "root":
          return "Client";
        case "client":
          return "Matter";
        default:
          return "Folder";
      }
    }

    add() {
      this.addPopupTitle = "Add " + this.getAddType();
      this.showAddPopup = true;
    }

    itemclick(node) {
      if (node.EntryType == "Document" && this.selectAllowed)
        return this.select(node);

      if (node.EntryType != "Document") return this.open(node);
    }

    itemclickrightcol(node) {
      const selectedNode = JSON.parse(JSON.stringify(node));
      if (selectedNode.EntryType != "Document") this.open(selectedNode);

      if (selectedNode.EntryType == "Document" && this.selectAllowed == true)
        this.previewNode = selectedNode;
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/browser/components/browserTable.component.js